/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyAuthCode_verifyAuthCode_Auth = { readonly __typename: 'Auth', readonly token: string };

export type VerifyAuthCode_Mutation = { readonly __typename: 'Mutation', readonly verifyAuthCode: VerifyAuthCode_verifyAuthCode_Auth | null };


export type VerifyAuthCodeVariables = _Types.Exact<{
  authCode: _Types.Scalars['String']['input'];
  email: _Types.Scalars['String']['input'];
}>;


export type VerifyAuthCode = VerifyAuthCode_Mutation;


export const VerifyAuthCodeDocument = gql`
    mutation VerifyAuthCode($authCode: String!, $email: String!) {
  verifyAuthCode(authCode: $authCode, email: $email) {
    token
  }
}
    `;
export type VerifyAuthCodeMutationFn = Apollo.MutationFunction<VerifyAuthCode, VerifyAuthCodeVariables>;

/**
 * __useVerifyAuthCode__
 *
 * To run a mutation, you first call `useVerifyAuthCode` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthCode` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthCode, { data, loading, error }] = useVerifyAuthCode({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useVerifyAuthCode(baseOptions?: Apollo.MutationHookOptions<VerifyAuthCode, VerifyAuthCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAuthCode, VerifyAuthCodeVariables>(VerifyAuthCodeDocument, options);
      }
export type VerifyAuthCodeHookResult = ReturnType<typeof useVerifyAuthCode>;
export type VerifyAuthCodeMutationResult = Apollo.MutationResult<VerifyAuthCode>;
export type VerifyAuthCodeMutationOptions = Apollo.BaseMutationOptions<VerifyAuthCode, VerifyAuthCodeVariables>;